/**
 * Filter
 *
 * @module filter
 */

 const component = {

    /**
     * Init component
     * 
     * @returns {boolean|undefined}
     */
	init: () => {
        
        component.target = document.querySelector('[data-filter]');

        if (!component.target)
            return false;

        component.closeFilter();
        component.initFocusTrap();
        component.initEvents();
	},


    /**
     * Init Events
     * 
     * @returns {undefined}
     */
    initEvents: () => {

        // Open button
        document.querySelector('[data-button-filter]').addEventListener('click', event => {
            event.preventDefault();
            component.openFilter();
        });

        // Close button
        document.querySelectorAll('[data-filter-close]').forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                component.closeFilter();
            });
        });

        // Close on window resize
        window.addEventListener('screen-breakpoint', event => {
            component.closeFilter();
        });

        // Close on mouse over
        hoverintent( component.target, () => {}, () => {
            component.closeFilter(); 
        });

        // Close filters on press escape
        window.addEventListener('escape', event => {
            component.closeFilter();
        });

        // Check the option on enter key press
        document.querySelectorAll('[data-filter-input-option], [data-filter-checkbox-option]').forEach(element => {
            element.addEventListener('keypress', event => {
                event = event || window.event;
                let key = event.key || event.keyCode;
                if (key === 'Enter' || key === 13) {                    
                    element.checked = !element.checked;
                }
            });
        });

        // Selection control for list items
        document.querySelectorAll('[data-filter-list-option-link]').forEach(element => {
            element.addEventListener('click', event => {
                let group = element.parentNode.parentNode.dataset.filterGroup;
                let items = document.querySelectorAll('[data-filter-group="' + group +'"] li');

                items.forEach( item => {
                    item.classList.remove('selected');
                });

                element.parentNode.classList.add('selected');
            });
        });

        // Sort by
        document.querySelectorAll('[data-sort-by-cards-item]').forEach(element => {
            element.addEventListener('click', event => {
                document.querySelector("[data-discount-sort-by='discount-descending']").classList.remove('active');
                document.querySelector("[data-discount-sort-by='discount-ascending']").classList.remove('active');

                let group = element.dataset.filterGroup;
                let items = document.querySelectorAll('[data-filter-group="' + group +'"]');

                items.forEach( item => {
                    if((item != element)&&(item.checked)){
                        item.checked = false;
                    } else {
                        let count = document.getElementById('activeFacetsCount').dataset.count;

                        if(window.screenMode == 'mobile' && window.location.search.includes('sort_by')) {
                            count = parseInt(count) + 1;
                        }
                
                        document.querySelectorAll('[data-filter-count]').forEach(element => {
                            element.dataset.filterCount = parseInt(count);
                        });
                    }
                });
            });

            element.addEventListener('keypress', event => {
                event = event || window.event;
                let key = event.key || event.keyCode;
                if (key === 'Enter' || key === 13) {                
                    element.click();
                }
            });
        });

    },

    /**
     * Open filter
     * 
     * @returns {undefined}
     */
    openFilter: () => {

        component.target.classList.remove('hidden');

        component.target.setAttribute('aria-hidden', 'false');

        // We need to use set time out to avoid issues with filter animation
        setTimeout(() => {
            component.target.classList.add('active');
            component.target.querySelector('[data-filter-close]').focus();
            component.activeFocusTrap();
        }, 5);
        
    },

    /**
     * Close filter
     * 
     * @returns {undefined}
     */
    closeFilter: () => {

        component.target.classList.remove("active");

        component.target.setAttribute('aria-hidden', 'true');

        component.disableFocusTrap();
		
		// We need to use set time out to avoid issues with filter animation
        setTimeout(() => {
            component.target.classList.add('hidden');
        }, 5);

    },

    /**
     * Init Focus Trap
     * 
     * @returns {undefined}
     */
    initFocusTrap: () => {

        component.focusTrap = focusTrap.createFocusTrap(component.target, { clickOutsideDeactivates: true });
    },

    /**
     * Disable Focus Trap
     * 
     * @returns {undefined}
     */
    disableFocusTrap: () => {

        if (component.focusTrap) {
            component.focusTrap.deactivate();
        }
    },

    /**
     * Active Focus Trap
     * 
     * @returns {undefined}
     */
    activeFocusTrap: () => {

        if (component.focusTrap) {
            component.focusTrap.activate();
        }
    }

};

export default component;
